/*** IMPORTS FROM imports-loader ***/
var define = false;

export default class Popups {

    constructor(params = {}) {

        this.closeSelector = params.closeSelector || '.popup__close';
        this.classActivePopup = params.classActivePopup || 'popup-wrapper--active';

        this.selectorPopupFaq = params.selectorPopupFaq || '#popup-faq';
        this.selectorPopupFaqContent = params.selectorPopupFaqContent || '#popup-faq--content';

        this.selectorIntegAP = params.selectorIntegAP || '#popup-integrated-ap';
        this.selectorIntegAPContent = params.selectorIntegAPContent || '#popup-integrated-ap--content';

        this.selectorWhatPackage = params.selectorWhatPackage || '#what-package';
        this.selectorWhatPackageContent = params.selectorWhatPackageContent || '#what-package--content';

        this.selectorSTE = params.selectorSTE || '#ste-social';
        this.selectorSTEContent = params.selectorSTEContent || '#ste-social--content';

        // this.selectorPopupPromoVideo = params.selectorPopupPromoVideo || '.promo-video__inner';
        // this.selectorPopupPromoVideoContent = params.selectorPopupPromoVideoContent || '#promo-video--content';
    }


    _popupOpenFaq() {
        this._openPopup(this.selectorPopupFaq, this.selectorPopupFaqContent);
    }

    _popupOpenIntegratedAP() {
        this._openPopup(this.selectorIntegAP, this.selectorIntegAPContent);
    }

    _popupOpenWhatPackage() {
        this._openPopup(this.selectorWhatPackage, this.selectorWhatPackageContent);
    }

    _popupOpenSTE() {
        this._openPopup(this.selectorSTE, this.selectorSTEContent);
    }

    _popupOpenPromoYouTubeVideo() {

        this.iFrameTube = $(this.selectorPopupPromoVideoContent).find('iframe');
        this.iFrameSrc = this.iFrameTube.attr('src');

        this._openPopup(this.selectorPopupPromoVideo, this.selectorPopupPromoVideoContent);
    }


    /**
     * @param selClick
     * @param selContent
     * @returns {boolean}
     * @private
     */
    _openPopup(selClick, selContent) {

        let selPopup = document.querySelector(selClick);
        let selPopupContent = document.querySelector(selContent);

        if (selPopup == undefined) return false;
        if (selPopupContent == undefined) return false;

        selPopup.addEventListener('click', () => {
            selPopupContent.classList.add(this.classActivePopup);
        });
    }

    _closePopup() {

        let _this = this;

        $(this.closeSelector).click(function () {
            $(this).closest('.' + _this.classActivePopup).removeClass(_this.classActivePopup);
            _this._refreshIFrameSrc();
        });

        document.addEventListener('click', function(e) {
            if (e.target && e.target.classList.contains(_this.classActivePopup)) {
                e.target.classList.remove(_this.classActivePopup);
                _this._refreshIFrameSrc();
            }
        });
    }

    _refreshIFrameSrc() {

        if (this.iFrameTube == undefined) return false;
        this.iFrameTube.attr('src', '');

        this.iFrameTube.attr('src', this.iFrameSrc);
    }

    init() {

        this._popupOpenFaq();

        this._popupOpenIntegratedAP();

        this._popupOpenWhatPackage();

        this._popupOpenSTE();

        this._popupOpenPromoYouTubeVideo();

        this._closePopup();
    }
}



// WEBPACK FOOTER //
// ./app/Sites/AT/assets/js/modules/Popups.js